import { render, staticRenderFns } from "./Food_safety_management.vue?vue&type=template&id=03669470&scoped=true"
import script from "./Food_safety_management.vue?vue&type=script&lang=js"
export * from "./Food_safety_management.vue?vue&type=script&lang=js"
import style0 from "./Food_safety_management.vue?vue&type=style&index=0&id=03669470&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03669470",
  null
  
)

export default component.exports